<template>
  <div>
    <v-autocomplete
      :value="value"
      @input="sendInput"
      :items="orgPositions"
      :disabled="mode == 'view'"
      dense
      item-text="POS_NAME"
      item-value="IPOS_ID"
      class="mr-5"
      label="Должность"
      :no-data-text="'Нет должностей для выбора'"
    >
      <template v-slot:append-outer v-if="mode === 'edit'">
        <v-icon
          color="primary"
          @click="showAddPositionDialog"
        >mdi-circle-edit-outline</v-icon>
      </template>
    </v-autocomplete>
    <org-add-position-dialog v-model="showAddPosition" :org="{ INST_UUID: org.INST_UUID }" @onPositionAdded="onPositionAdded" />
  </div>
</template>

<script>
import OrgAddPositionDialog from '@/components/modules/org/structure/staff/dialogs/addPositionDialog'
export default {
  name: 'orgPositionSelect',
  components: { OrgAddPositionDialog },
  props: {
    value: {
      type: String,
      default: null
    },
    mode: {
      type: String,
      default: 'view'
    },
    org: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: () => ({
    showAddPosition: false
  }),
  computed: {
    orgPositions: {
      get: function () {
        return this.$store.getters.getOrgPositions
      }
    }
  },
  methods: {
    sendInput (val) {
      this.$emit('input', val)
    },
    showAddPositionDialog () {
      this.showAddPosition = true
    },
    onPositionAdded (val) {
      this.showAddPosition = false
      this.sendInput(val.IPOS_ID)
    }
  }
}
</script>

<style scoped>

</style>
